import NP from "number-precision";
import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import api from "@/api";
import { upperFirst, camelCase } from "lodash";
import { cookies } from "@/plugins/cookie";

Vue.config.productionTip = false;

// 将api挂载到vue的原型上复制代码
Vue.prototype.$cookies = cookies;
Vue.prototype.$api = (module, method, params) => {
  return api[module][method](params);
};

//全局混入
Vue.mixin({
  computed: {
    areaName() {
      const area = {
        one: "北京",
        two: "海淀"
      };
      return area[this.position];
    }
  },
  methods: {
    //路由定向方法
    redirectByPath(path, query) {
      this.$router.push({
        path,
        query
      });
    },
    // 自定义的setInterval 参数一 timer的名字(当前定时器的指针 ) 参数二 callback回调函数 参数三 间隔时间
    customInterval(timer, callback, time) {
      const fn = () => {
        this[timer] = setTimeout(() => {
          callback();
          fn();
        }, time);
      };
      fn();
    },
    // 种子随机数
    seedRandom(seed, min, max) {
      min = min || 0;
      max = max || 1;
      seed = (seed * 9301 + 49297) % 233280;
      var rnd = seed / 233280.0;
      return Math.floor(rnd * (max - min + 1)) + min; //取整
    },
    //根据id创建种子
    createSeed(id) {
      let seed = 0;
      id.split("").map(function(item) {
        seed += item.charCodeAt(0);
      });
      return seed;
    },
    // 处理服务器返回数据方式一
    processDataWayOne(res, key, value, colors, coefficient) {
      let one = [],
        two = [];
      if (res.code === 0) {
        res.dataList.map(item => {
          const data = item.dataList.map((x, i) => {
            const color = colors[i];
            // i < colors.length ? colors[i] : colors[i - colors.length];
            // data->label颜色
            const label = {
              color
            };
            // data->itemStyle颜色
            const itemStyle = {
              color
            };
            return {
              label,
              itemStyle,
              name: x[key],
              value: coefficient ? NP.times(x[value], coefficient) : x[value]
            };
          });
          switch (item.name) {
            case "北京":
              one = data;
              break;
            case "海淀":
              two = data;
              break;
          }
        });
      }
      return {
        one,
        two
      };
    },
    // 处理服务器返回数据方式二
    processDataWayTwo(res, key, value1, value2) {
      let one = [],
        two = [],
        fnc = list => {
          let data1 = [],
            data2 = [];
          list.map(item => {
            data1.push({
              name: item[key],
              value: item[value1]
            });
            data2.push({
              name: item[key],
              value: parseFloat(item[value2])
            });
          });
          return [data1, data2];
        };
      if (res.code === 0) {
        one = fnc(res.bjList);
        two = fnc(res.hdList);
      }
      return {
        one,
        two
      };
    },
    // 处理服务器返回数据方式三
    processDataWayThree(res, key, value, colors) {
      let data = [];
      if (res.code === 0) {
        data = res.dataList.map((item, i) => {
          const color =
            i < colors.length ? colors[i] : colors[i - colors.length];
          // data->label颜色
          let label = {
              color
            },
            // data->itemStyle颜色
            itemStyle = {
              color
            };
          return {
            label,
            itemStyle,
            name: item[key],
            value: Number.parseFloat(item[value])
          };
        });
      }
      return data;
    }
  }
});

// 自动化全局注册
const requireComponent = require.context(
  // 其组件目录的相对路径
  "../components",
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式
  /\w+\.(vue|js)$/
);
requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName);

  // 获取组件的 PascalCase 命名
  const componentName = upperFirst(
    camelCase(
      // 获取和目录深度有关的文件名
      fileName
        .split("/")
        .slice(1)
        .join("_")
        .replace(/\.\w+$/, "")
    )
  );

  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default || componentConfig
  );
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
